import React from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import { SkeletonCard } from '../../components/SkeletonCard';
import styles from './SetupStorePreview.scss';
import { useTranslation } from '@wix/wix-i18n-config';

export function SetupStorePreview() {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <Box direction="vertical" gap="12px" className={styles.header}>
        <Heading size="extraLarge">{t('setup_store_preview.heading')}</Heading>
        <Text size="medium" secondary>
          {t('setup_store_preview.description')}
        </Text>
      </Box>

      <div className={styles.grid}>
        {Array.from({ length: 9 }).map((_, index) => (
          <SkeletonCard key={index} shimmer size="150px" />
        ))}
      </div>

      <Text size="small" secondary className={styles.footerText}>
        {t('setup_store_preview.footer')}
      </Text>
    </div>
  );
}
